jQuery(document).ready(function ($){
    'use strict';

    $(document).on('click', '.participant-register', function(e) {
        e.preventDefault();

        let $button = $(this);
        let $count = $('.partisipants-count span');
        let $count_value = parseFloat( $count.text() ) + 1;
        let $message = $('.registration-message');
        let $validation = $('.registration-validation');
        let $name = $('#participant_name');
        let $email = $('#participant_email');
        let $phone = $('#participant_phone');
        let fd = new FormData();

        $validation.text('');

        if ( $button.hasClass('guest') ) {
            if($name.val() === undefined || $name.val() === null || $name.val() === '') {
                $button.removeClass('loading');
                $validation.text('Namn är obligatoriskt.');
                return;
            }

            if($email.val() === undefined || $email.val() === null || $email.val() === '') {
                $button.removeClass('loading');
                $validation.text('E-post är obligatoriskt.');
                return;
            }

            if($phone.val() === undefined || $phone.val() === null || $phone.val() === '') {
                $button.removeClass('loading');
                $validation.text('Telefon är obligatoriskt.');
                return;
            }
        }

        fd.append('user_id', $button.data('user-id'));
        fd.append('event_id', $button.data('event-id'));
        fd.append('participant_name', $name.val());
        fd.append('participant_email', $email.val());
        fd.append('participant_phone', $phone.val());
        fd.append('action', 'participant_register');

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: fd,
            contentType: false,
            processData: false,
            beforeSend: function(data) {
                $button.addClass('loading');
            },
            success: function(data) {
                $button.removeClass('loading').hide();
                $message.show();
                $count.text( $count_value );
                $name.val('').removeClass('has-value').prev().removeClass('has-value');
                $email.val('').removeClass('has-value').prev().removeClass('has-value');
                $phone.val('').removeClass('has-value').prev().removeClass('has-value');
            },
            error: function(xhr, textStatus, error) {
                $button.removeClass('loading');
                $validation.text('Denna e-post är redan registrerad');
            },
        });

    });

    $(document).on('click', '.participant-unregister', function(e) {
        e.preventDefault();

        let $button = $(this);
        let $count = $('.partisipants-count span');
        let $count_value = parseFloat( $count.text() ) - 1;
        let $message = $('.registration-message');
        let fd = new FormData();

        fd.append('participant_id', $button.data('participant-id'));
        fd.append('action', 'participant_unregister');

        $.ajax({
            type: 'POST',
            url: '/wp-admin/admin-ajax.php',
            data: fd,
            contentType: false,
            processData: false,
            beforeSend: function(data) {
                $button.addClass('loading');
            },
            success: function(data) {
                $button.removeClass('loading').hide();
                $message.show();
                $count.text( $count_value );
            },
            error: function(xhr, textStatus, error) {
                $button.removeClass('loading');
            },
        });

    });
});